module.exports = __webpack_public_path__ + "img/forte1.7a9817b5.jpeg";